// Hocs
import asyncRoute from '../AsyncRoute'

import { ASSET_ROUTE_URLS } from '../constants'
import getRequestName from '../components/getRequestName'

// Exports
export function getComponent ({store}) {
  return new Promise((resolve) => {
    require.ensure([], (require) => {
      const View = require('hfty-assets-dom').AssetsManager
      const requestInfoMaskHoc = require('fc-requests').requestInfoMaskHoc
      const requestInfo$ = require('fc-requests').getFilteredRequestsInProgress$(ASSET_ROUTE_URLS)

      resolve(requestInfoMaskHoc({
        requestInfo$,
        getRequestName,
      })(View))

    /* Webpack named bundle   */
    }, 'assets')
  })
}

export default asyncRoute({getComponent, reducers: []})
